import { createContext, useContext } from 'react';

import { ListType } from '@components/integrations/integrations-types';
import { FieldMappingGroup } from '@components/text-editors/addons/field-mapping';

import { CreateFormBuilderStoreType } from './create-builder-store';

export type PredefinedOptionsLists = Array<{
  value: string;
  label: string;
  options: Array<{ value: string; label: string }>;
  isHidden: boolean;
  listType: ListType;
  isSyncActive?: boolean;
}>;

export type MarketplaceIntegrationList = {
  shortId: string;
  name: string;
  options: Array<{ value: string; label: string }>;
  listType: 'manual' | 'synced';
  isSyncActive: boolean;
};

export type MarketplaceIntegrationWithLists = {
  shortId: string;
  name: string;
  logo: string;
  lists: MarketplaceIntegrationList[];
};

export type FormBuilderContextValue = {
  store: CreateFormBuilderStoreType;
  predefinedOptionsLists: PredefinedOptionsLists;
  marketplaceIntegrationLists?: MarketplaceIntegrationWithLists[];
  variableGroups?: FieldMappingGroup[];
  onJourneyAttributeListChange?: (journeyAttributeId: string, listId: string | null) => void;
};
export type FormBuilderContextType = FormBuilderContextValue | undefined;

export const FormBuilderContext = createContext<FormBuilderContextType>(undefined);

export const useFormBuilderContext = () => {
  const context = useContext(FormBuilderContext);
  if (!context) throw new Error('Missing FormBuilderContext');

  return context;
};

export const FormBuilderContextProvider = FormBuilderContext.Provider;
